module.exports = __webpack_public_path__ + "img/vacant.732dc7aa.svg";